//Generated File 
export default class ACCEntities{
	static readonly AccDistribution = `AccDistribution`;
	static readonly Account = `Account`;
	static readonly AccountCategory = `AccountCategory`;
	static readonly AccountChartType = `AccountChartType`;
	static readonly AccountTaxCategory = `AccountTaxCategory`;
	static readonly AccountsChart = `AccountsChart`;
	static readonly AggTreasuryBillProofDoc = `AggTreasuryBillProofDoc`;
	static readonly AggregatedInvestmentDocROIProof = `AggregatedInvestmentDocROIProof`;
	static readonly AgingAllocation = `AgingAllocation`;
	static readonly BLCChanging = `BLCChanging`;
	static readonly BLCClosingDoc = `BLCClosingDoc`;
	static readonly BLCOpeningDoc = `BLCOpeningDoc`;
	static readonly BLCReq = `BLCReq`;
	static readonly Bank = `Bank`;
	static readonly BankAccount = `BankAccount`;
	static readonly BankAdjustment = `BankAdjustment`;
	static readonly BankLC = `BankLC`;
	static readonly BankLCType = `BankLCType`;
	static readonly BankLoan = `BankLoan`;
	static readonly BankLoanChangingDoc = `BankLoanChangingDoc`;
	static readonly BankLoanRequest = `BankLoanRequest`;
	static readonly BankLoanScheduling = `BankLoanScheduling`;
	static readonly BankLoanType = `BankLoanType`;
	static readonly BankNotice = `BankNotice`;
	static readonly BankPortfolio = `BankPortfolio`;
	static readonly BankReconciliation = `BankReconciliation`;
	static readonly BankTransfer = `BankTransfer`;
	static readonly CSHCloseShift = `CSHCloseShift`;
	static readonly CSHOpenShift = `CSHOpenShift`;
	static readonly CSHPaymentVoucher = `CSHPaymentVoucher`;
	static readonly CSHReceiptVoucher = `CSHReceiptVoucher`;
	static readonly ClosingEntry = `ClosingEntry`;
	static readonly ConsolidatedPVRequest = `ConsolidatedPVRequest`;
	static readonly ConsolidatedRVRequest = `ConsolidatedRVRequest`;
	static readonly CreditFacility = `CreditFacility`;
	static readonly CreditFacilityIssuance = `CreditFacilityIssuance`;
	static readonly CreditFacilityPayment = `CreditFacilityPayment`;
	static readonly CreditFacilitySetting = `CreditFacilitySetting`;
	static readonly CreditFacilityTermination = `CreditFacilityTermination`;
	static readonly CreditNote = `CreditNote`;
	static readonly CurrencyDiffJournal = `CurrencyDiffJournal`;
	static readonly DebitNote = `DebitNote`;
	static readonly ElectronicReceiptVoucher = `ElectronicReceiptVoucher`;
	static readonly ExchangeRateUpdate = `ExchangeRateUpdate`;
	static readonly FPBook = `FPBook`;
	static readonly FPPartialPayment = `FPPartialPayment`;
	static readonly FPReceiptRequest = `FPReceiptRequest`;
	static readonly FPTransfer = `FPTransfer`;
	static readonly FSAccountGroup = `FSAccountGroup`;
	static readonly FSEquation = `FSEquation`;
	static readonly FSIssueFile = `FSIssueFile`;
	static readonly FSIssueLinkConfig = `FSIssueLinkConfig`;
	static readonly FSSettingsFile = `FSSettingsFile`;
	static readonly FacilityLimit = `FacilityLimit`;
	static readonly FacilityLimitConfig = `FacilityLimitConfig`;
	static readonly FinancialBudget = `FinancialBudget`;
	static readonly FinancialCommitment = `FinancialCommitment`;
	static readonly FinancialCommitmentCategory = `FinancialCommitmentCategory`;
	static readonly FinancialCommitmentPayDoc = `FinancialCommitmentPayDoc`;
	static readonly FinancialCommitmentReschedule = `FinancialCommitmentReschedule`;
	static readonly FinancialPaper = `FinancialPaper`;
	static readonly FinancialPaperAgio = `FinancialPaperAgio`;
	static readonly FinancialPaperAgioReturn = `FinancialPaperAgioReturn`;
	static readonly FinancialPaperCancel = `FinancialPaperCancel`;
	static readonly FixedDeposit = `FixedDeposit`;
	static readonly FixedDepositChangingDoc = `FixedDepositChangingDoc`;
	static readonly FixedDepositIssue = `FixedDepositIssue`;
	static readonly FundType = `FundType`;
	static readonly IPCashDeposit = `IPCashDeposit`;
	static readonly IPInvestmentAllocation = `IPInvestmentAllocation`;
	static readonly IPInvestmentBudget = `IPInvestmentBudget`;
	static readonly IPInvestmentEnd = `IPInvestmentEnd`;
	static readonly IPInvestmentFund = `IPInvestmentFund`;
	static readonly IPInvestmentIncreaseCapital = `IPInvestmentIncreaseCapital`;
	static readonly IPInvestmentOpportunity = `IPInvestmentOpportunity`;
	static readonly IPInvestmentPortfolio = `IPInvestmentPortfolio`;
	static readonly IPInvestmentProfitDistribution = `IPInvestmentProfitDistribution`;
	static readonly IPInvestmentRefund = `IPInvestmentRefund`;
	static readonly IPInvestmentStart = `IPInvestmentStart`;
	static readonly IPInvestmentUpdate = `IPInvestmentUpdate`;
	static readonly IPShare = `IPShare`;
	static readonly IPShareType = `IPShareType`;
	static readonly IPStake = `IPStake`;
	static readonly IPStakeType = `IPStakeType`;
	static readonly InterCompanyTransfer = `InterCompanyTransfer`;
	static readonly InterestPaymentDocument = `InterestPaymentDocument`;
	static readonly InvestmentCompany = `InvestmentCompany`;
	static readonly InvestmentDoc = `InvestmentDoc`;
	static readonly InvestmentDocClaiming = `InvestmentDocClaiming`;
	static readonly InvestmentDocPurchase = `InvestmentDocPurchase`;
	static readonly InvestmentDocROIProof = `InvestmentDocROIProof`;
	static readonly InvestmentDocumentFund = `InvestmentDocumentFund`;
	static readonly InvestmentDocumentPriceUpdate = `InvestmentDocumentPriceUpdate`;
	static readonly InvestmentDocumentPurchase = `InvestmentDocumentPurchase`;
	static readonly InvestmentDocumentSale = `InvestmentDocumentSale`;
	static readonly InvestmentProject = `InvestmentProject`;
	static readonly Investor = `Investor`;
	static readonly JournalEntry = `JournalEntry`;
	static readonly LGTChanging = `LGTChanging`;
	static readonly LGTClosing = `LGTClosing`;
	static readonly LGTDelivery = `LGTDelivery`;
	static readonly LGTIssue = `LGTIssue`;
	static readonly LGTOpeningDoc = `LGTOpeningDoc`;
	static readonly LGTReceipt = `LGTReceipt`;
	static readonly LGTReq = `LGTReq`;
	static readonly Ledger = `Ledger`;
	static readonly LedgerReviseDoc = `LedgerReviseDoc`;
	static readonly LetterOfGuarantee = `LetterOfGuarantee`;
	static readonly LoanInstallmentPayment = `LoanInstallmentPayment`;
	static readonly LoanInterestsCalculation = `LoanInterestsCalculation`;
	static readonly LoanIssue = `LoanIssue`;
	static readonly MachineRentInvoice = `MachineRentInvoice`;
	static readonly MiscPurchaseInvoice = `MiscPurchaseInvoice`;
	static readonly MiscPurchaseOrder = `MiscPurchaseOrder`;
	static readonly MiscPurchaseReq = `MiscPurchaseReq`;
	static readonly OpenningFinancialPaper = `OpenningFinancialPaper`;
	static readonly PVRequest = `PVRequest`;
	static readonly Partner = `Partner`;
	static readonly PartyEvalElementGroup = `PartyEvalElementGroup`;
	static readonly PartyEvaluation = `PartyEvaluation`;
	static readonly PartyEvaluationElement = `PartyEvaluationElement`;
	static readonly PaymentOrder = `PaymentOrder`;
	static readonly PaymentVoucher = `PaymentVoucher`;
	static readonly PostponedBankPortfolio = `PostponedBankPortfolio`;
	static readonly PostponedPortfolioReturn = `PostponedPortfolioReturn`;
	static readonly PrepaidExpenseContract = `PrepaidExpenseContract`;
	static readonly PrepaidExpenseItem = `PrepaidExpenseItem`;
	static readonly PrepaidExpenseLedger = `PrepaidExpenseLedger`;
	static readonly PrepaidExpensePayment = `PrepaidExpensePayment`;
	static readonly PreventAccTransactions = `PreventAccTransactions`;
	static readonly ProfitDistributationDoc = `ProfitDistributationDoc`;
	static readonly PurchaseElement = `PurchaseElement`;
	static readonly PurgeJournal = `PurgeJournal`;
	static readonly RVRequest = `RVRequest`;
	static readonly ReceiptOrder = `ReceiptOrder`;
	static readonly ReceiptVoucher = `ReceiptVoucher`;
	static readonly SubsidiaryReconciliation = `SubsidiaryReconciliation`;
	static readonly SystemAccountTransException = `SystemAccountTransException`;
	static readonly TrasureyBillROIProofDoc = `TrasureyBillROIProofDoc`;
	static readonly TreasuryBill = `TreasuryBill`;
	static readonly TreasuryBillCloseDoc = `TreasuryBillCloseDoc`;
	static readonly TreasuryBillPurchaseDoc = `TreasuryBillPurchaseDoc`;
	static readonly TreasuryBillSalesDoc = `TreasuryBillSalesDoc`;
}
